import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

export default function ProtectedRoute({ children }) {
  const [status, setStatus] = useState("checking");
  const navigate = useNavigate();

  useEffect(() => {
    const check = async () => {
      try {
        await api.get("/auth/me");
        setStatus("authed");
      } catch (e) {
        setStatus("unauthed");
        navigate("/admin/login", { replace: true });
      }
    };
    check();
  }, [navigate]);

  if (status === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-heirloom-bone">
        <p className="font-display text-2xl text-heirloom-obsidian">Loading…</p>
      </div>
    );
  }
  if (status === "unauthed") return null;
  return children;
}
